import {
  Box,
  Button,
  Card,
  CardActionArea,
  CardContent,
  CardMedia,
  Container,
  Divider,
  IconButton,
  Typography,
} from "@mui/material";
import { ArrowBackIos, ArrowForwardIos } from "@mui/icons-material";
import { useEffect, useRef, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { fetchAllRecipes } from "../firebase/fireStoreServices";

export default function FeaturedRecipe() {
  const navigate = useNavigate();

  // Ref for scrolling
  const scrollRef = useRef(null);

  // Function to scroll left
  const scrollLeft = () => {
    scrollRef.current.scrollBy({ left: -360, behavior: "smooth" });
  };

  // Function to scroll right
  const scrollRight = () => {
    scrollRef.current.scrollBy({ left: 360, behavior: "smooth" });
  };

  const [recipesData, SetRecipesData] = useState([]);

  // Fetching Recipe data from database through service layer i.e. firebase/fireStoreServices
  useEffect(() => {
    const loadRecipes = async () => {
      const recipesData = await fetchAllRecipes();
      SetRecipesData(recipesData);
    };
    loadRecipes();
  }, []);

  return (
    <Container maxWidth="lg" sx={{ mt: 3, bgcolor: "white", borderRadius: 4 }}>
      <Divider>
        <Typography
          variant="h4"
          fontWeight="bold"
          textAlign="center"
          gutterBottom
          color="secondary"
        >
          Featured Recipes
        </Typography>
      </Divider>

      {/* Scrollable Container with Arrows */}
      <Box sx={{ position: "relative", overflow: "hidden", mt: 1, p: 3 }}>
        {/* Left Arrow Button */}
        <IconButton
          sx={{
            position: "absolute",
            left: 0,
            top: "50%",
            transform: "translateY(-50%)",
            bgcolor: "white",
            boxShadow: 2,
            zIndex: 2,
            "&:hover": { bgcolor: "#f5f5f5" },
          }}
          onClick={scrollLeft}
        >
          <ArrowBackIos />
        </IconButton>

        {/* Scrollable Card Container */}
        <Box
          ref={scrollRef}
          sx={{
            display: "flex",
            overflowX: "auto",
            scrollBehavior: "smooth",
            scrollbarWidth: "none", // Hide scrollbar in Firefox
            "&::-webkit-scrollbar": { display: "none" }, // Hide scrollbar in Chrome
          }}
        >
          {recipesData.map((recipe) => (
            <Card
              key={recipe.id}
              sx={{
                maxWidth: 350,
                m: 1,
                boxShadow: 5,
                borderRadius: 3,
                flexShrink: 0,
                transition: "transform 0.3s, box-shadow 0.3s",
                "&:hover": {
                  transform: "scale(1.05)",
                  boxShadow: 15,
                },
              }}
            >
              <CardActionArea component={Link} to={`/recipe/${recipe.id}`}>
                <CardMedia
                  component="img"
                  height="200"
                  image={recipe.image}
                  alt={recipe.title}
                  loading="lazy"
                  sx={{ objectFit: "cover", width: "100%" }}
                />
                <CardContent>
                  <Typography
                    variant="h6"
                    fontWeight="bold"
                    sx={{ textAlign: "center" }}
                  >
                    {recipe.title}
                  </Typography>
                  <Typography variant="body2" color="textSecondary">
                    {recipe.description}
                  </Typography>
                </CardContent>
              </CardActionArea>
            </Card>
          ))}
        </Box>

        {/* Right Arrow Button */}
        <IconButton
          sx={{
            position: "absolute",
            right: 0,
            top: "50%",
            transform: "translateY(-50%)",
            bgcolor: "white",
            boxShadow: 2,
            zIndex: 2,
            "&:hover": { bgcolor: "#f5f5f5" },
          }}
          onClick={scrollRight}
        >
          <ArrowForwardIos />
        </IconButton>

        <Box textAlign="center" mt={4}>
          <Button
            variant="contained"
            color="secondary"
            onClick={() => navigate("/recipes")}
          >
            View All Recipes
          </Button>
        </Box>
      </Box>
    </Container>
  );
}
